import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

const defaultExpBufferingThresholdInMs: number = 250;

@Component({
	selector: 'vb-overlay-buffering',
	template: `
		<div
			class="bufferingContainer"
			[hidden]="!showBufferingOverlay">
			<div [ngClass]="spinnerClass">
				<svg viewBox="0 0 100 100">
					<circle class="pip"
						cx="50"
						cy="50"
						r="42"
					/>
				</svg>
			</div>
		</div>
	`,
	standalone: false,
	styleUrls: ['./VbOverlayBuffering.Component.ng.less']
})
export class VbOverlayBufferingComponent implements OnChanges, OnInit {
	@Input() public experiencedBufferingThresholdInMs: number;
	@Input() public isBuffering: boolean;
	@Input() public isSmallSizePlayer: boolean;

	@Output() public onBufferingSpinner = new EventEmitter<{ duration: number }>();
	public spinnerClass: string = this.getSpinnerClass();

	private overlayEligibleToVisible: boolean;
	private overlayDelayTimeoutRef: number;
	private experiencedBufferingTime: number;

	public ngOnInit(): void {
		this.experiencedBufferingThresholdInMs = this.experiencedBufferingThresholdInMs || defaultExpBufferingThresholdInMs;
	}

	public ngOnChanges(changes: SimpleChanges): void {
		this.triggerOverlayVisibility();
		if (changes.isBuffering || changes.isSmallSizePlayer) {
			this.spinnerClass = this.getSpinnerClass();
		}
	}

	public getSpinnerClass(): string {
		return [
			'loadingSpinner',
			this.isSmallSizePlayer ? 'medium' : 'large',
			this.isBuffering ? 'active' : ''
		].join(' ');
	}

	public get showBufferingOverlay(): boolean {
		return this.overlayEligibleToVisible;
	}

	public set showBufferingOverlay(value) {
		this.overlayEligibleToVisible = value;
	}

	private triggerOverlayVisibility(): void {
		if (this.isBuffering) {
			this.delayOverlayVisibility();
		} else {
			if (this.overlayDelayTimeoutRef) {
				window.clearTimeout(this.overlayDelayTimeoutRef);
				this.overlayDelayTimeoutRef = undefined;
				this.overlayEligibleToVisible = false;

				if (this.experiencedBufferingTime) {
					const duration = Date.now() - this.experiencedBufferingTime;
					this.experiencedBufferingTime = undefined;
					this.triggerBufferingSpinnerEvent(duration);
				}
			}
		}
	}

	private delayOverlayVisibility(): void {
		if (this.overlayDelayTimeoutRef) {
			return;
		}
		this.overlayDelayTimeoutRef = window.setTimeout(() => {
			if (this.isBuffering) {
				this.overlayEligibleToVisible = this.isBuffering;
				this.experiencedBufferingTime = Date.now();
			}
		}, this.experiencedBufferingThresholdInMs);
	}

	private triggerBufferingSpinnerEvent(duration: number): void {
		this.onBufferingSpinner.emit({
			duration
		});
	}
}
